import { Box, CHART_COLOR_NAMES, InfoDot, Text } from '@factorialco/deprecated-design-system'

type Datum = { label: string; value: number }

type Props = {
  data: Datum[]
}

const HeadcountByGenderLegend = ({ data }: Props) => {
  return (
    <Box gap="s24">
      {data.map((datum, index) => (
        <Box flexDirection="row" key={datum.label} gap="s16">
          <Box gap="s4" flexDirection="row" flexGrow>
            <Box flexNoShrink>
              <InfoDot size="medium" color={CHART_COLOR_NAMES[index % CHART_COLOR_NAMES.length]!} />
            </Box>
            <Text.Normal capitalize weight="medium" size="100">
              {datum.label}
            </Text.Normal>
          </Box>
          <Text.Normal weight="bold" size="100">
            {datum.value}
          </Text.Normal>
        </Box>
      ))}
    </Box>
  )
}

export default HeadcountByGenderLegend
